import { render, staticRenderFns } from "./OEEDetalleNyxV2.vue?vue&type=template&id=61e3e33e&scoped=true&"
import script from "./OEEDetalleNyxV2.vue?vue&type=script&lang=js&"
export * from "./OEEDetalleNyxV2.vue?vue&type=script&lang=js&"
import style0 from "./OEEDetalleNyxV2.vue?vue&type=style&index=0&id=61e3e33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3e33e",
  null
  
)

export default component.exports